import React from "react";
import "./NotFoundComponentAlt.scss";

interface INotFoundComponentAltProps {
  user: any;
  message: string | JSX.Element;
  subMessage?: string;
  showSubMessage?: boolean;
  group: any
  hideBoxShadow?: boolean;
}

const NotFoundComponentAlt = (props: INotFoundComponentAltProps) => {
  return <div className={props.user ? "not-found-container-logged-in" : "not-found-container-logged-out"}>
    <div className={`not-found-content ${props.hideBoxShadow ? 'box-shadow-none' : ''}`}>
      <img src={require("../link.png")} alt="link" />
      {typeof props.message === "string" ? (
        <div className="heading">{props.message}</div>
      ) : (
        <>
          {props.message}
        </>
      )}

      {props.showSubMessage && (<p className="sub-heading">
        {props.subMessage ?
          props.subMessage
          :
          <span>Create a group and make it yours!{" "}</span>
        }
        <a className="not-found-link"
          href="#"
          onClick={() => {}}>
          {props.user ? "Create now!" : "Sign up now!"}
        </a>
      </p>)}
    </div>
  </div>;
}

export default NotFoundComponentAlt;
